export const StockOnHand = {
    productName: '',
    warehouseName: '',
    qty: 0,
}